import { LadderLinker } from "./LadderLinker";
import { Users } from "../models/UserCollection";
import LadderEmoji from "react/elements/LadderEmoji";
import { emojiSegments } from "functions/chatEmoji";
import React from "react";
import { UserComponent } from "../react/UserComponent";
import { ChatRoom } from "models/ChatRoom";
import RoomLinkChip from "react/chat/RoomLinkChip";
import { ROOM_LINK_TOKEN, DELETED_ROOM_TEXT, findLinkedRoom, plainRoomLinkText as plainText } from "functions/roomLinks";

// Spells tokens out as #Name, preferring the names of rooms you're in.
export function plainRoomLinkText(text, linkedRooms = null) {
	return plainText(text, linkedRooms, ChatRoom.activeChats);
}

import {
	autoReplaceRegex,
	getMyUsernameRegex,
} from "./contstants/CommonRegularExpressions";

export default class MessageParser {

	constructor() {
		this.children = [];
		this.usernamesFound = {};
	}

	updateProps(props) {
		this.props = props;
		this.emojiCounter = 0;

		const { linkText, text, options, renderLink, tagName, authoredByMe, linkedRooms, ...childProps } = this.props;

		this.children = [];

		this.parseRegularLinks();
		this.createChildren(); // Has to be after the regular links parse right now

		this.parseCommands();

		if(linkText) {
			this.parseAutoReplaces();
		}
		this.parseEmojiAutoReplaces();
		if(linkText) {
			this.parseCasualMentions();
		}
	}

	static doRegularExpressionReplacement(children, piece, regex, foundPieceFunction) {
		if(!_.isString(piece)) {
			return piece;
		}
		if(!regex.test(piece)) {
			return piece;
		}
		return foundPieceFunction(piece);
	}

	parseRegularLinks() {
		const { text } = this.props;
		const tags = [];
		this.usernamesFound = {};
		const pieces = String(text).split(ROOM_LINK_TOKEN);
		// split() with a capture group alternates text and room ids.
		pieces.forEach((piece, index) => {
			if(index % 2 === 1) {
				tags.push({ roomLinkId: Number.parseInt(piece, 10) });
				return;
			}
			if(piece) {
				tags.push(...this.autolinkText(piece));
			}
		});
		this.tags = tags;
	}

	autolinkText(text) {
		const { options } = this.props;
		const tags = [];
		let currentStringOffset = 0;
		Autolinker.link(text, {
			...options,
			replaceFn: (autolinker, match) => {
				const tag = autolinker.getTagBuilder().build(match);
				tag.addClass('autolinked');
				tag.setInnerHtml(match.getMatchedText());
				let result = null;
				switch(match.getType()) {
					case 'url':
						result = LadderLinker.autolinkUrl(tag, match);
						break;
					case 'hashtag':
						result = LadderLinker.autolinkHashtag(tag, match);
						if(!result) {
							return false; // Plain text: stays in the surrounding string.
						}
						break;
					case 'email':
						result = tag;
						break;
					case 'twitter':
						result = LadderLinker.autolinkUsername(tag, match);
						const user = Users.retrieveByUsername(match.getTwitterHandle());
						if(user.id) {
							this.usernamesFound[user.id] = user;
						}
						break;
				}
				const offset = text.indexOf(match.matchedText, currentStringOffset);
				if(offset > currentStringOffset) {
					tags.push(text.substring(currentStringOffset, offset));
				}
				currentStringOffset = offset + match.matchedText.length;
				tags.push(tag);
				return tag;
			}
		});
		if(currentStringOffset < text.length) {
			tags.push(text.substring(currentStringOffset, text.length));
		}
		return tags;
	}

	linkedRoom(roomId) {
		return findLinkedRoom(roomId, this.props.linkedRooms, ChatRoom.activeChats);
	}

	renderRoomLink(roomId, key) {
		const { linkText } = this.props;
		const room = this.linkedRoom(roomId);
		if(!linkText) {
			return room === null ? DELETED_ROOM_TEXT : `#${room ? room.name : roomId}`;
		}
		if(room === null) {
			return <span key={key} className='room_link_chip room_link_chip--gone' title='Room deleted'>{DELETED_ROOM_TEXT}</span>;
		}
		const name = room ? room.name : `#${roomId}`;
		return <RoomLinkChip key={key} roomId={roomId} name={name} colors={room ? room.colors : null} />;
	}

	createChildren() {
		const { linkText, renderLink } = this.props;
		const children = this.children;
		this.tags.forEach((tag, index) => {
			if(_.isString(tag)) {
				children.push(tag);
				return;
			}
			if(tag.roomLinkId && (!tag.attrs || this.linkedRoom(tag.roomLinkId) !== undefined)) {
				children.push(this.renderRoomLink(tag.roomLinkId, `room-link-${index}`));
				return;
			}
			if(!linkText) {
				children.push(tag.innerHtml);
				return;
			}
			if(tag.attrs && tag.attrs.class) {
				tag.attrs.className = tag.attrs.class;
				delete tag.attrs.class;
			}
			tag.attrs.key = `${tag.attrs.href}-${index}`;
			children.push(renderLink(tag));
		});
	}

	parseCommands() {
		const children = this.children;
		if(children[0] && _.isString(children[0]) && children[0].startsWith('/')) {
			const splitFirstMessage = _.trimEnd(children[0]).split(' ');
			if(splitFirstMessage.length > 1) {
				const [firstMessage, ...theOthers] = splitFirstMessage;
				const command = (<span key='command' className='message_command'>{firstMessage}{' '}</span>);
				children.splice(0, 1, command);
				children.splice(1, 0, theOthers.join(' '));
			}
		}
	}

	parseAutoReplaces() {
		const children = this.children;
		children.forEach((child, index) => {
			if(!_.isString(child)) {
				return;
			}
			const autoReplaces = child.split(autoReplaceRegex)
				.map((piece) => {
					return MessageParser.doRegularExpressionReplacement(children, piece, autoReplaceRegex, (foundPiece) => {
						const ladderLinkerMatch = LadderLinker.autoReplaces[foundPiece];
						if(ladderLinkerMatch && ladderLinkerMatch.link) {
							return (
								<a
									key={`autoreplace-${++this.emojiCounter}`}
									target='_blank'
									href={ladderLinkerMatch.link}>
									{foundPiece}
								</a>
							);
						}
						return foundPiece;
					});
				});

			children.splice(index, 1, ...autoReplaces);
		});
	}

	parseEmojiAutoReplaces() {
		this.children = this.children.flatMap(child => typeof child !== 'string' ? [child] :
			emojiSegments(child).map(segment => typeof segment === 'string' ? segment :
				<LadderEmoji emoji={segment.native} key={`emoji-${++this.emojiCounter}`} />));
	}

	parseCasualMentions() {
		// Your own name in your own message is not a mention.
		if(this.props.authoredByMe && this.props.authoredByMe()) {
			return;
		}
		const children = this.children;
		children.forEach((child, index) => {
			if(!_.isString(child)) {
				return;
			}
			const usernameFindings = child.split(getMyUsernameRegex())
				.map((piece) => {
					return MessageParser.doRegularExpressionReplacement(children, piece, getMyUsernameRegex(), (foundPiece) => {
						this.usernamesFound[myUser.id] = myUser;
						return <React.Fragment
							key={`emoji-${++this.emojiCounter}`}
						>{' '}
							<UserComponent
								className='casual_mention'
								title='You have been casually mentioned'
								showUsernameAs={foundPiece}
								showModGavel={false}
								user={myUser}
							/>
						</React.Fragment>;
					});
				});

			children.splice(index, 1, ...usernameFindings);
		});
	}


}